import { Select, SelectProps } from 'zens-storybook'
import React from 'react'
import { StyleSheet } from 'react-native'
import { useLocations } from 'zens-store'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
})

interface Props extends Omit<SelectProps<number>, 'items' | 'onSelect'> {
  companyId: number
  onChange?: (value: number) => void
}
const LocationSelect = (props: Props) => {
  const { companyId, onChange, ...otherProps } = props

  const locations = useLocations({ companyId })

  const items = locations.data?.map((location) => ({
    value: location.id,
    title: location.name,
  }))
  return (
    <Select
      style={styles.container}
      onSelect={onChange}
      items={items}
      testID="LocationSelect.Container"
      {...otherProps}
    />
  )
}

export default LocationSelect
